import ReactCookies from 'react-cookies';
import axios from '../components/_generic/axiosSplunk/axiosSplunk';
import COOKIES from '../config/cookies/cookies';
import {
  SITE_LIVINGSOCIAL_IE,
  SITE_WOWCHER,
  SITE_WOWCHERIE,
  SUGGESTED_SEARCH_API,
  SUGGESTED_SEARCH_API_V2,
  SUGGESTEDSEARCHURL,
  UNBOXED_SUGGESTED_SEARCH_API,
} from '../config/setup/setup';
import httpCommonHeaders from './httpCommonHeaders';

export const getDefaultSuggestions = () => {
  return process.env.NEXT_PUBLIC_BRAND === SITE_LIVINGSOCIAL_IE
    ? [
        'mattress',
        'radiator cover',
        'gaming chair',
        'bed',
        'chair',
        'weighted blanket',
        'headboard',
        'blanket',
        'tablet',
      ]
    : [
        'spa',
        'bed',
        'mattress',
        'spa day',
        'city break',
        'afternoon tea',
        'holiday',
        'hotel',
        'london',
        'massage',
        'laptop',
        'sofa',
      ];
};

export const getSearchSuggestions = async (searchTerm) => {
  const ssTest = ReactCookies.load(COOKIES.ssTest);

  let url;
  if (ssTest === 'b') {
    url = `${
      SUGGESTED_SEARCH_API_V2[process.env.NEXT_PUBLIC_ENVIRONMENT || 'prod'][
        process.env.NEXT_PUBLIC_SITE || 'wowcher'
      ]
    }?q=${searchTerm}`;
  } else {
    url = `${
      SUGGESTED_SEARCH_API[process.env.NEXT_PUBLIC_ENVIRONMENT || 'prod'][
        process.env.NEXT_PUBLIC_SITE || 'wowcher'
      ]
    }?q=${searchTerm}`;
  }
  try {
    const response = await axios({
      headers: httpCommonHeaders(),
      method: 'get',
      url,
    });

    if (response && response.data && response.data.length > 0)
      return response.data;

    return null;
  } catch {
    return null;
  }
};
